import "./Home.css";
import Profile from "./Profile";
import Footer from "./Footer";

const Home = (props) => {
    return (
        <div id={props.id} className="home-container">
            <Profile />
            <Footer />
        </div>
    )
}

export default Home;